<template>
  <v-row class="text--primary">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Últimas cotações
        </v-subheader>
        <v-divider/>
        <px-ultimas-cotacoes-produto-table :produto="itemAprovacao.produto" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import UltimasCotacoesProdutoTable
  from '@/modules/cotacao/cotacoes-produtos/UltimasCotacoesProdutoTable.vue';

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  components: {
    pxUltimasCotacoesProdutoTable: UltimasCotacoesProdutoTable,
  },
};
</script>
